import Marquee from "react-fast-marquee";

const ITEMS = ["Author", "CEO", "Visionary", "Franchise Builder", "Leader", "Entrepreneur"];

export const EditorialMarquee = ({ className = "" }) => (
  <div
    data-testid="editorial-marquee"
    className={`border-y border-white/10 py-6 overflow-hidden ${className}`}
  >
    <Marquee speed={25} gradient={false} pauseOnHover>
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display italic font-light text-2xl md:text-3xl tracking-wide text-white/60 mx-12">
            {item}
          </span>
          <span className="w-2 h-2 rounded-full bg-brand inline-block" />
        </span>
      ))}
    </Marquee>
  </div>
);
